import React, { useEffect, useState } from 'react';
import { Typography, Grid } from '@mui/material';
import { listImageUrls } from '../../api';
import { useAlerts } from '../../alerts';

const Photos = () => {
  const { setError, clearErrors } = useAlerts();
  const [imageUrls, setImageUrls] = useState([]);

  useEffect(() => {
    listImageUrls().then(urls => {
      setImageUrls(urls);
    }).catch(error => {
      setError(error ?? 'Unable to load photos. Please try again.');
    });

    return () => clearErrors();
  }, []);

  return (
    <div>
      <Typography variant='h1' gutterBottom>Photos</Typography>

      <Grid container>
        {imageUrls.map((url, index) => (
          <Grid item key={index} xs={6} sm={4} md={3}>
            <img src={url} alt='User-provided' style={{ width: '100%', height: 'auto' }} />
          </Grid>
        ))}
      </Grid>
    </div>
  );
}
export default Photos;